import RestClient from './RestClient';
// Direct import: SalepointsField is pulled via FormLayout → components barrel
// while models/index is still loading FormLayout; importing Salepoint from the
// barrel then hits an uninitialized live binding.
import Salepoint from '../../models/Salepoint';

class Salepoints extends RestClient {
    constructor() {
        super({
            "model": Salepoint,
            "entryPoint": "salepoint",
            "resource": "salepoint",
            "resources": "salepoints",
            "id_field": "_id"
        });
    }
}

const SalepointsApi = new Salepoints();

export default SalepointsApi;
